import { render, staticRenderFns } from "./documents.pnd54.vue?vue&type=template&id=6a448f03&scoped=true"
import script from "./documents.pnd54.vue?vue&type=script&lang=js"
export * from "./documents.pnd54.vue?vue&type=script&lang=js"
import style0 from "./documents.pnd54.vue?vue&type=style&index=0&id=6a448f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a448f03",
  null
  
)

export default component.exports